import styles from './Loading.module.css';

import type { FC } from 'react';

import logo from 'src/assets/images/logo.png';

import { Image } from 'src/components/themed/Image';
import { Stack } from 'src/components/themed/Stack';
import { Indicator } from 'src/components/themed/Indicator';
import { RequestFailureState } from 'src/components/EmptyState';

type LoadingProps = {
  progress?: number;
  /** The splash has held the app past its limit: say so and offer a way out instead of the bar. */
  stalled?: boolean;
  onRetry?: () => void;
};

export const Loading: FC<LoadingProps> = (props) => {
  const { progress, stalled, onRetry } = props;

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      flex={1}
      gap={8}
      pb={10}
      className={styles.container}
    >
      <Image src={logo} alt="GAC" />
      {stalled ? (
        <RequestFailureState kind="timeout" onRetry={onRetry} />
      ) : typeof progress === 'number' ? (
        <Indicator progress={progress} width={158} />
      ) : null}
    </Stack>
  );
};
